import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Alert } from '../Alert.js'

export const ChooseForm = ({ onSubmit, courseId, courses, formErrorMsg }) => {
  const [courseIdInput, setCourseIdInput] = useState(courseId || -1)
  const [errorMsg, setErrorMsg] = useState(formErrorMsg)

  useEffect(() => {
    setErrorMsg(formErrorMsg)
  }, [formErrorMsg])

  useEffect(() => {
    setCourseIdInput(courseId)
  }, [courseId])

  const postFormData = event => {
    event.preventDefault()
    if (courseIdInput === -1 || courseIdInput === '') {
      return setErrorMsg('You must select a course.')
    }
    onSubmit(courseIdInput)
  }

  const generateSpinner = optionalClass => (
    <div className={classNames(optionalClass, 'spinner-holder')}>
      <div
        className="icon icon_spinner10 icon_spin2"
        style={{ fontSize: '50px' }}
      />
    </div>
  )

  const generateSelectField = () => {
    const courseOptions = courses.map(obj => (
      <option value={obj.id} key={obj.id}>
        {obj.name}
      </option>
    ))

    return (
      <select
        onChange={e => setCourseIdInput(e.target.value)}
        value={courseIdInput}
        className="form-control"
      >
        {courseOptions}
      </select>
    )
  }

  const hasCanvasCourses = courses && courses.length !== 0
  const selectHtml = hasCanvasCourses
    ? generateSelectField()
    : generateSpinner('main')

  const msg =
    errorMsg === '' ? null : (
      <Alert bootstrapClass="danger" message={errorMsg} />
    )

  return (
    <div>
      {msg}
      <form onSubmit={postFormData} className="canvas-settings-form">
        <label>
          <br />
          {selectHtml}
        </label>
        <br />
        <div className="form-control-wrapper">
          <button
            className="btn btn-myed btn-primary btn-primary-myed"
            type="submit"
          >
            Next <div className="fa-solid fa-chevron-right ml-2" />
          </button>
        </div>
      </form>
    </div>
  )
}

ChooseForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  courseId: PropTypes.string.isRequired,
  courses: PropTypes.array,
  formErrorMsg: PropTypes.string,
}
